import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

const StyledListContainer = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;
`;

const StyledNumberPageItem = styled.li<{
  $isCurrentPageNumber: boolean;
  $disabled: boolean;
}>`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.variables.border_radius_1};
  border: 2px solid
    ${(props) =>
      props.$isCurrentPageNumber ? theme.colors.purple : "transparent"};
  cursor: ${(props) => (props.$disabled ? "auto" : "pointer")};
  pointer-events: ${(props) => (props.$isCurrentPageNumber ? "none" : "auto")};
`;

const StyledChevronItem = styled.button<{ disabled: boolean }>`
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  background: none;
  border: none;
`;

export { StyledListContainer, StyledChevronItem, StyledNumberPageItem };
